export const SOCIAL_LINKS = {
  Discord: 'https://discord.gg/5HdcdBp9FE',
  Twitter: 'https://twitter.com/CryptoCanvasArt',
}



// WEBPACK FOOTER //
// ./src/constants.js